import { combineReducers } from "redux";
import alertSlice from "./Alert/alert.slice";
import authenticationSlice from "./authentication/authentication.slice";
import loaderSlice from "./Loader/loader.slice";
import APIListingSlice from "./APILisiting/APIListing.slice";
import selectedAPIsSlice from "./selectedAPIs/selectedAPIs.slice";
import pageDataSlice from "./pageData/pageData.slice";
import chartStateSlice from "./chartState/chartState.slice";
import toastSlice from "./Toast/toast.slice";

const rootReducer = combineReducers({authentication : authenticationSlice, alertState: alertSlice, loaderState: loaderSlice, APIListingState: APIListingSlice, selectedAPIs: selectedAPIsSlice, pageData: pageDataSlice, chartState: chartStateSlice, toastState: toastSlice})

export default rootReducer